<template>
  <div class="login">
    <div class="form_box">
      <div class="title">
        <img src="../../assets/images/login/login_title.png" alt="" />
      </div>
      <el-form
        ref="form"
        :model="user"
        :rules="rules"
        class="form"
        @keydown.enter.native="preSubmit"
      >
        <el-form-item v-if="!isLogin">
          <el-input placeholder="请输入姓名" v-model="user.name"> </el-input>
          <i class="icon_name" />
        </el-form-item>
        <el-form-item prop="mobile">
          <el-input placeholder="请输入手机号" v-model="user.mobile" />
          <i class="icon_phone" />
        </el-form-item>
        <el-form-item prop="verification_code">
          <el-input
            class="code"
            placeholder="请输入验证码"
            v-model="user.verification_code"
          >
          </el-input>
          <i class="icon_code" />
          <a v-show="sendAuthCode" @click="code">获取验证码</a>
          <span v-show="!sendAuthCode">（{{ time }}S）</span>
        </el-form-item>
      </el-form>
      <div class="tip">
        <span
          v-if="isLogin"
          @click="
            () => {
              this.isLogin = false;
              this.sendAuthCode = true;
            }
          "
          >没有账号？点击注册</span
        >
        <span
          v-else
          @click="
            () => {
              this.isLogin = true;
              this.sendAuthCode = true;
            }
          "
          >已有账号？点击登录</span
        >
      </div>
      <el-button :loading="submitLoading" type="primary" @click="preSubmit">
        {{ isLogin ? "登录" : "注册" }}</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      liveroomId: this.$route.query.liveroom_id || undefined,
      submitLoading: false,
      time: 0,
      sendAuthCode: true,
      isLogin: true,
      user: {
        mobile: "",
        name: "",
        verification_code: "",
        verification_key: ""
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        verification_code: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ]
      }
    };
  },
  computed: {},
  methods: {
    // 获取验证码
    code() {
      // 获取验证码
      const mobile = this.$setting.checkMobile(this.user.mobile);
      if (this.user.mobile === "") {
        this.$message.error("请输入手机号！");
      } else if (!mobile) {
        this.$message.error("请填写正确的手机号！");
      } else {
        this.sendAuthCode = false;
        this.time = 60;
        const auth_timer = setInterval(() => {
          this.time--;
          if (this.time <= 0) {
            this.sendAuthCode = true;
            clearInterval(auth_timer);
          }
        }, 1000);
        const data = {
          mobile: this.user.mobile,
          action: this.isLogin ? "login" : "register"
        };
        this.$http
          .post("/api/verificationCodes/mobile", data)
          .then(res => {
            this.user.verification_key = res.key;
            this.$message.success("发送验证码成功！");
          })
          .catch(err => {
            if (
              err.response.data.code === 10005 ||
              err.response.data.code === 10010
            ) {
              setTimeout(() => {
                window.location.reload();
              }, 2000);
            }
          });
      }
    },
    // 登录 注册
    preSubmit() {
      if (this.liveroomId) {
        this.$refs.form.validate(valid => {
          if (valid) {
            // 登录
            if (this.user.verification_key === "") {
              this.$message.success("请先获取验证码！");
            } else {
              if (this.isLogin) {
                const data = {
                  verification_key: this.user.verification_key,
                  verification_code: this.user.verification_code
                };
                this.$http.post("/api/oauth/token-mobile", data).then(res => {
                  this.$message.success("登录成功！");
                  this.$token.set(res.access_token);
                  this.join();
                });
              } else {
                if (this.user.name === "") {
                  this.$message.error("请输入姓名！");
                } else {
                  const data = {
                    name: this.user.name,
                    mobile: this.user.mobile,
                    password: "a123456",
                    verification_key: this.user.verification_key,
                    verification_code: this.user.verification_code
                  };
                  this.$http.post("/api/users", data).then(res => {
                    this.$message.success("注册成功，初始密码为a123456！");
                    setTimeout(() => {
                      this.$token.set(res.accessToken.access_token);
                      this.join();
                    }, 2000);
                  });
                }
              }
            }
          }
        });
      } else {
        this.$message.error("该地址无效，请输入正确的访问地址！");
      }
    },
    // 加入直播间
    join() {
      this.$http
        .get(`/api/student/liveroom/info/${this.liveroomId}`)
        .then(res => {
          if (res.is_end === 1) {
            this.$message.error("直播已结束！");
          } else if (res.is_lack === 1) {
            this.$message.error("老师缺课！");
          } else {
            if (res.check_type === 1) {
              // 判断是否需要输入验证码
              this.$prompt("请输入验证码", "提示", {
                showClose: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                confirmButtonText: "确定",
                cancelButtonText: "取消"
              })
                .then(res => {
                  // 检验直播间验证码
                  this.$http
                    .post(
                      `/api/student/liveroom/${this.liveroomId}/check_code`,
                      { code: res.value }
                    )
                    .then(() => {
                      this.$message.success("验证成功!");
                      setTimeout(() => {
                        this.$router.push({
                          path: "/room",
                          query: {
                            liveroom_id: this.liveroomId
                          }
                        });
                      }, 500);
                    })
                    .catch(() => {
                      setTimeout(() => {
                        window.location.reload();
                      }, 2000);
                    });
                })
                .catch(() => {
                  window.location.reload();
                });
            } else {
              setTimeout(() => {
                this.$router.push({
                  path: "/room",
                  query: {
                    liveroom_id: this.liveroomId
                  }
                });
              }, 500);
            }
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  width: 100vw;
  height: 100vh;
  background-image: url("../../assets/images/login/login_bg.png");
  background-position: center center;
  background-size: cover;
  .form_box {
    width: 719px;
    height: auto;
    border-radius: 15px;
    padding-bottom: 50px;
    background: rgba(255, 255, 255, 0.5);
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    .title {
      width: 244px;
      height: 153px;
      margin: 50px auto 0;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .form {
      width: 400px;
      margin: 17px auto 0;
      .el-form-item {
        width: 100%;
        box-sizing: border-box;
        position: relative;
        .el-input {
          /deep/ input {
            border: 2px solid #ffb70b;
            border-radius: 5px;
            height: 50px;
            line-height: 50px;
            padding-left: 50px;
            font-size: 18px;
            color: #333;
            background: rgba(255, 183, 11, 0.1);

            &::-webkit-input-placeholder {
              /* WebKit, Blink, Edge */
              color: #999;
            }
            &:-moz-placeholder {
              /* Mozilla Firefox 4 to 18 */
              color: #999;
            }
            &::-moz-placeholder {
              /* Mozilla Firefox 19+ */
              color: #999;
            }
            &:-ms-input-placeholder {
              /* Internet Explorer 10-11 */
              color: #999;
            }
            &::-ms-input-placeholder {
              /* Microsoft Edge */
              color: #999;
            }
          }
          &.code {
            /deep/ input {
              padding-right: 100px;
            }
          }
        }
        i {
          display: block;
          position: absolute;
          left: 17px;
          top: 13px;
          z-index: 10;
          &.icon_phone {
            width: 18px;
            height: 26px;
            background: url("../../assets/images/login/icon_phone.png")
              no-repeat;
            background-size: 100% 100%;
          }
          &.icon_name {
            width: 21px;
            height: 22px;
            background: url("../../assets/images/login/icon_name.png") no-repeat;
            background-size: 100% 100%;
            left: 15px;
          }
          &.icon_code {
            width: 20px;
            height: 22px;
            background: url("../../assets/images/login/icon_code.png") no-repeat;
            background-size: 100% 100%;
          }
        }
        a,
        span {
          padding-left: 15px;
          border-left: 1px solid #696969;
          display: block;
          width: auto;
          height: 16px;
          line-height: 16px;
          position: absolute;
          right: 10px;
          top: 17px;
          font-size: 16px;
          color: #999;
          z-index: 10;
          cursor: pointer;
        }
      }
    }
    .tip {
      margin: -15px auto 0;
      width: 400px;
      text-align: right;
      font-size: 14px;
      color: #696969;
      span {
        display: inline-block;
        cursor: pointer;
        &:hover {
          color: #fd8f00;
        }
      }
    }
    .el-button {
      margin-top: 50px;
      width: 348px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      letter-spacing: 10px;
      background: #fd8f00;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14);
      font-size: 20px;
      color: #fff;
      padding: 0;
      border: 0;
      font-weight: 400;
      &:hover {
        background: #ffb70b;
      }
    }
  }
}
</style>
